
//une el context y el firebase

import firebase from './firebase';
import FirebaseContext from './context';

export{ FirebaseContext}

export default firebase;